/** @jsx jsx */
import React, { useCallback } from 'react';
import { css, jsx } from '@emotion/core';

import productColor, { textFontSize } from 'components/styles';
import Icon from 'components/atoms/Icon';
import BodyText from 'components/atoms/BodyText';


const styles = {
  wrapper: css({
    width: '100%',
    borderTop: `1px solid ${productColor.primary}`,
  }),
  content: css({
    display: 'block',
    width: '100%',
    paddingLeft: '5px',
    paddingBottom: '15px',
  }),
  button: css({
    // margin: '6px 8px',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    padding: '15px 0px',
    fontFamily: 'inherit',
    text: textFontSize.re,
    minWidth: '140px',
    textAlign: 'left',
  }),
  hidden: css({
    display: 'none',
  }),
  label: css({
    marginLeft: '4px',
    fontSize: '16px',
  }),
};

interface AccordionProps {
  text: string;
  color: string;
  defaultExpand?: boolean;
  accordionValue?: string;
  callBack: () => void;
}

const Accordion: React.FC<AccordionProps> = ({
  children, text, color, defaultExpand = false, accordionValue, callBack,
}) => {
  const [isExpand, setExpand] = React.useState(defaultExpand);


  const onClick = useCallback(() => {
    setExpand(!isExpand);
    sessionStorage.setItem(`attendHolidayManagement.accordion.${accordionValue}`, String(!isExpand));
    callBack();
  }, [accordionValue, callBack, isExpand]);

  return (
    <React.Fragment>
      <div css={css(styles.wrapper)}>
        <button type="button" css={styles.button} onClick={onClick}>
          {
          isExpand
            ? <Icon type="chevronDown" color={color} />
            : <Icon type="chevronRight" color={color} />
        }
          <BodyText customStyle={styles.label}>{text}</BodyText>
        </button>

        <div css={css(styles.content, !isExpand ? styles.hidden : '')}>
          {children}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Accordion;
